import React from "react";
import { Link } from "react-router-dom";
import { ThemeToggle } from "../components/ThemeToggle";
import { LangSwitcher } from "../components/LangSwitcher";
import { useTheme } from "../context/ThemeContext";

export function AuthShell({ title, subtitle, children, footer }) {
  const { theme } = useTheme();
  const word = theme === "dark" ? "/logo_word_dark.png" : "/logo_word_light.png";
  const mono = theme === "dark" ? "/logo_mono_dark.png" : "/logo_mono_light.png";
  return (
    <div className="min-h-screen bg-[#F7FBFA] flex flex-col">
      <div className="h-16 flex items-center justify-between px-4 sm:px-6 border-b border-[#D5E7E5]">
        <Link to="/" aria-label="Lura Finance"><img src={word} alt="Lura Finance" className="h-9 w-auto" /></Link>
        <div className="flex items-center gap-2">
          <LangSwitcher />
          <ThemeToggle />
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md">
          <div className="bg-white border border-[#D5E7E5] rounded-lg p-6 sm:p-8">
            <img src={mono} alt="" aria-hidden="true" className="h-12 w-auto mx-auto mb-5" />
            <h1 className="text-2xl font-bold tracking-tight text-[#075E62] text-center">{title}</h1>
            {subtitle && <p className="text-sm text-[#5F8588] mt-1.5 mb-6 text-center">{subtitle}</p>}
            {children}
          </div>
          {footer && <div className="text-center text-sm text-[#5F8588] mt-4">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function googleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}
